// Número de WhatsApp de GUILLOS Kitchen (mismo que figura en el Footer)
export const WHATSAPP_NUMBER = '5491164615467';

export const BUSINESS_NAME = 'GUILLOS Kitchen';

// El backend ahora es PHP, servido desde el mismo origen que el sitio (sin puerto aparte).
// Para desarrollo local con PHP corriendo aparte (ej: WAMP, o `php -S`), definí
// REACT_APP_API_URL en .env.local apuntando a esa dirección (ej: http://localhost:8080/api).
export const API_URL = process.env.REACT_APP_API_URL || '/api';
export const API_ORIGIN = API_URL.startsWith('http') ? API_URL.replace(/\/api$/, '') : '';
